import "./App.css";
import {
  ChatWidget,
  ChatWidgetConfig,
  ChatWidgetInit,
} from "./components/ChatWidget";

// Export the ChatWidget components and types for external usage
export { ChatWidget, ChatWidgetInit, type ChatWidgetConfig };

// Token storage for managing authentication
let currentAuthToken =
  "eyJraWQiOiI1NFcwMFRjaXh2dUk5VldLYUd5ZjQwdWdyZTdcL3NCMUdMMjV2V3lvcDFZND0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI5NDU4NTRiOC1iMDgxLTcwN2MtZmJhYy1kYWM4ZDAzNTRhY2QiLCJjb2duaXRvOmdyb3VwcyI6WyJTeXN0ZW1BZG1pbiJdLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tXC91cy1lYXN0LTFfMTRtNDdJWkJHIiwicGhvbmVfbnVtYmVyX3ZlcmlmaWVkIjp0cnVlLCJjb2duaXRvOnVzZXJuYW1lIjoiYW5hbmQudGlwcGFuYUB4Y3ViZWxhYnMuY29tIiwiY3VzdG9tOmFwcGxpY2F0aW9uX3R5cGUiOiJOVE1EIiwib3JpZ2luX2p0aSI6IjA1MjVmZGI3LTgwYjgtNDRlMC04MjE2LTJkYmFhMzMzOWFlMyIsImF1ZCI6IjdtZjF1b21rc3Y3czl1OGhwcmxoNHFuNmZpIiwiZXZlbnRfaWQiOiJjNWNkM2E2ZC1iNThhLTQwODYtODg4YS0wNGUzYzI1M2RjNDMiLCJ0b2tlbl91c2UiOiJpZCIsImN1c3RvbTppc19zdXBlcmFkbWluIjoidHJ1ZSIsImF1dGhfdGltZSI6MTc2MTgxOTkxMywicGhvbmVfbnVtYmVyIjoiKzkxOTAxMDE4MTk2OCIsImV4cCI6MTc2MTgyMDIxMywiaWF0IjoxNzYxODE5OTEzLCJqdGkiOiIwMDNmNWViMi03MzRjLTRhZDctOWY1OC1lYTA2ZTMwMTdmMTciLCJlbWFpbCI6ImFuYW5kLnRpcHBhbmFAeGN1YmVsYWJzLmNvbSJ9.mi5YmQlE61WUl3O9sQqQw5a9eczO2dohSkgI0FCf59r4kSgZ-V1PjK5iEqj4BavsEBCN3VIRqRTVYMhL9rDdgmhR6JzzHWmQskPwb1kAjo08PwJR6h1E52XYl5lOplmajLWfwwPjhb_9f1CbGC-1-B_Tv4qmmsL_j55Q6-BwKaHDvLpy22iYiwrI2QI4bCPAUDpZAUnzh5kg8p-VnJ4tp_DtoQcRbKW7oDRT7C7GEsEV4NL6YoIPtsNfZ6l8fAw8ZxmBJtaks0CRxELSIYzoCUuqCx1mLBPzP9dIXn303OeQtfTsM59Ig3Vii5K2bf9zh0N7Fgj3cw60-Cfl44e9QA";

// Example configuration for external applications
export const defaultChatConfig: ChatWidgetConfig = {
  userMetadata: undefined, // Should be set by external app with user info

  // Bot Configuration
  botName: "NopalCyber Assistant",
  welcomeMessage:
    "Hello! I'm your NopalCyber assistant. How can I help you today?",

  // Appearance
  theme: {
    primaryColor: "#f97316",
    backgroundColor: "#ffffff",
    textColor: "#1f2937",
    borderRadius: "0.5rem",
    themeMode: "dark"
  },
  position: {
    bottom: "1rem",
    right: "1rem",
  },
  size: {
    width: "400px",
    height: "600px",
  },

  // Behavior
  autoOpen: false,
  enableMaximize: true,
  enableMinimize: true,
  enableSounds: false,
  enableTypingIndicator: true,
  placeholder: "Type your message...",
  maxMessageLength: 1000,
  zIndex: 1000,

  // Authentication (to be implemented by external application)
  getAuthToken: () => {
    return currentAuthToken;
  },

  // Event handlers (examples)
  onMessage: (message) => {
    // console.log("User message:", message);
  },
  onResponse: (response) => {
    // console.log("Bot response:", response);
  },
  onError: (error) => {
    console.error("Chat error:", error);
  },
  // Token refresh handler - called when 401/403 occurs
  onTokenExpired: async () => {
    console.log("Token expired, attempting refresh...");
  },
};

// This is a reference implementation for integration testing only
// External applications should NOT import this App component
// Instead, use ChatWidget or ChatWidgetInit directly (see integration docs)
function App() {
  return (
    <div className="App">
      {/* Reference implementation - shows ChatWidget with default config */}
      <ChatWidget config={defaultChatConfig} />
    </div>
  );
}

// NOTE: Only export for development/testing purposes
// External apps should import { ChatWidget, ChatWidgetInit } directly
export default App;
